import React, { useRef } from "react";
import "./LandingHero.css";

const LandingHero = () => {
  const subheading = useRef(false);

  const handleTypeAnimationEnd = (e) => {
    const elem = e.target;
    if (elem.matches(".landing-hero__w-0.landing-hero__type-animation")) {
      elem.classList.remove("landing-hero__w-0");
      if (!elem.classList.contains("landing-hero__subheader")) {
        subheading.current.classList.add("landing-hero__type-animation");
        elem.classList.remove("landing-hero__type-animation");
      } else {
        setTimeout(
          () => elem.classList.remove("landing-hero__type-animation"),
          5000
        );
      }
    }
  };

  return (
    <div className="landing-hero__container" id="landing">
      <div className="text-primary landing-hero__header-container">
        <div
          className="landing-hero__header landing-hero__w-0 landing-hero__type-animation"
          onAnimationEnd={(e) => handleTypeAnimationEnd(e)}
        >
          Ferdz Duterte
        </div>
      </div>
      <div className="landing-hero__header-container">
        <div
          ref={subheading}
          className="landing-hero__subheader landing-hero__w-0"
          onAnimationEnd={(e) => handleTypeAnimationEnd(e)}
        >
          Fullstack Web Developer
        </div>
      </div>
    </div>
  );
};

export default LandingHero;
